<template>
  <TemplatePreset
    v-if="pageData"
    :isShowAgreementSelect="!hasQualify"
    @agree-change="handleAgreeChange"
  >
    <div slot="main">
      <StaticContent :list="pageData.content"></StaticContent>
    </div>
    <Bottom
      slot="bottom"
      :config="pageData.bottom"
      :isPaySuccess="isPaySuccess"
      :isAgree="isAgree"
      :hasQualify="hasQualify"
      @pay="payHandle"
      @go-next="isShowPopup = true"
    ></Bottom>
    <div slot="fix-items">
      <Loading ref="loading"></Loading>
      <Toast ref="toast"></Toast>
      <PopupTipSuccess
        :qrcode="wechatQrcode"
        :textConfig="popupText"
        :isShow="isShowPopup"
        @close="isShowPopup = false"
      ></PopupTipSuccess>
    </div>
  </TemplatePreset>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';
import Bottom from '../components/Bottom.vue';
import TemplatePreset from '@/modules/common/TemplatePreset.vue';
import StaticContent from '../components/StaticContent.vue';
import PopupTipSuccess from '@/modules/common/PopupTipSuccess';
import Toast from '@/components/Toast';
import {
  setCookie,
  getCookie,
  addHashQuery,
  getQueryFromSearch,
} from '@/lib/util.ts';
import { Route } from 'vue-router/types/router';
import { getChannel, PayChannel, executeCharge } from '@/lib/pingpp';
import { getItem, setItem } from '../utils';
import { promiseLock } from '@/lib/decorates';
import Loading from '@/components/Loading';
import ProxyImg from '@/modules/common/ProxyImg';
import {
  ks,
  douyin,
  loadScript,
  ThirdPart,
  ITracker,
} from '@/lib/third-part-tracker';
import { makeTracker } from '@/lib/tracker';
import ScrollTracker from '@/lib/ScrollTracker';
const CHARGE_ID = 'h5_enrolment_change_id';
interface ITrackData { convert_id: string; tracking_id?: string }
@Component({
  components: {
    TemplatePreset,
    Toast,
    Bottom,
    Loading,
    ProxyImg,
    StaticContent,
    PopupTipSuccess,
  },
  beforeRouteEnter(to: Route, from: Route, next: Function) {
    if (window.isWechat) {
      next({
        name: 'ForwardCenter',
        redirect: true,
        query: to.query,
      });
      return;
    }
    window.Al.start();
    window.np.start();
    window.apis.getWapStaticRes(to.query).then((res: any) => {
      window.Al.done();
      window.np.done();
      next((vm: any) => {
        vm.initResource(res);
      });
    });
  },
})
export default class Home extends Vue {
  pageData: any = null;
  productionId = 9;
  isAgree = true;
  isPaySuccess = false; // 支付成功，在前端拿到支付回调，防止重复支付
  hasQualify = false; // 获得资格，是等待后端处理完的结果
  timeout: any;
  chargeId = '';
  popupText = {
    status: '已购买',
    guide: ['截图保存二维码', '打开微信扫码关注'],
    tip: '进行课程激活',
    warn: '（未激活不能参加学习）',
    footer: ['也可直接打开微信，搜索【python小课】', '关注公众号开始学习'],
  };
  isShowPopup = false;
  wechatQrcode = '';
  sensorData: any = {};
  trackerPromise: Promise<ITracker> | null = null;
  convertId = '0';
  scrollTracker: ScrollTracker | null = null;
  track = (event: string, p: any): any => {}; // 神策埋点封装默认属性
  trackData: ITrackData = { convert_id: '0' }; // 第三方数据上报相关信息
  successUrl = '';
  get storeKey() {
    return CHARGE_ID + '_' + this.productionId;
  }
  get price() {
    let i: any = this.pageData;
    i && (i = i.bottom) && (i = i.button) && (i = i.price);
    return i ? Number(i) : -1;
  }
  mounted() {
    // 注意这里是去拿 slot 的 dom 节点
    setTimeout(() => {
      const el = document.getElementById('t-scroll-container');
      if (el) {
        this.scrollTracker = new ScrollTracker(
          (start, end) => {
            this.track('PageScroll', {
              tracking_subscene: '报名页浏览',
              roll_direction: start < end ? 'down' : 'up',
              start_v: start,
              end_v: end,
              actual_price: this.price,
              page_name: this.sensorData.page_name || 'unknown',
            });
          },
          el,
          400
        );
        this.scrollTracker.register();
      }
    });
  }
  async initResource(res: any) {
    const data = res.data;
    if (data.redirect_url) {
      const href = addHashQuery(data.redirect_url, this.$route.query);
      window.location.replace(href);
    }
    if (data.production_id) {
      this.productionId = data.production_id;
    }
    // const url = await this.judgeRedirect(); //使用 chargeId 判断是否进行重定向。
    // if (url) {
    //   window.location.replace(url);
    //   return;
    // }
    this.pageData = data;
    if (data.success_modal) {
      this.popupText = data.success_modal;
    }
    if (data.qrcode) {
      this.wechatQrcode = data.qrcode;
    }
    const chargeId = getItem(this.storeKey) || this.$route.query.success;
    if (chargeId) {
      this.startPollCharge(chargeId);
    }
    if (data.sensor) {
      this.sensorData = data.sensor || {};
    }
    if (data.track_data) {
      this.trackData = data.track_data;
    }
    this.successUrl = data.success_redirect_url;
    // 第三方数据回传
    this.convertId = this.trackData.convert_id;
    if (data.track_type) {
      this.trackerPromise = loadScript(
        data.track_type,
        this.trackData.tracking_id
      );
    }
    this.styleFix(); // 平台样式修复
    this.initTrack(); // 设置默认参数
    this.track('PageView', {
      tracking_subscene: '报名页浏览',
      user_type_: this.sensorData.user_type_ || 'unknown',
      page_name: this.sensorData.page_name || 'unknown',
    });
  }
  judgeRedirect() {
    const key = this.storeKey;
    const chargeId = this.$route.query.success || getItem(key);
    if (chargeId) {
      return window.apis
        .getWapRedirecrt({ ...this.$route.query, chargeId })
        .then((res: any) => {
          const {
            data: { redirect_url },
          } = res;
          return redirect_url;
        })
        .catch(() => {
          return false;
        });
    }
    return Promise.resolve(false);
  }
  initTrack() {
    const commonTrackerKey = [
      'spm_client',
      'spm_channel',
      'spm_type',
      'spm_version1',
      'spm_version2',
    ];
    const commonTrackPayload: any = {
      tracking_scene: '9元报名页',
      from: this.$route.query.From || 'unknown',
      from_version: this.$route.query.FromVersion || 'unknown',
      production_id: this.productionId,
      production_type: this.sensorData.production_type || 'app',
    };
    for (const key of commonTrackerKey) {
      commonTrackPayload[key] = this.sensorData[key] || 'unknown';
    }
    this.track = makeTracker(commonTrackPayload);
  }
  handleAgreeChange(isAgree: boolean) {
    this.isAgree = isAgree;
  }
  setLoading(toggle: boolean) {
    let i = this.$refs.loading;
    if (i && (i = i.setToggle)) {
      i(toggle);
    }
  }
  toast(conf: any) {
    let i = this.$refs.toast;
    if (i && (i = i.toast)) {
      i(conf);
    }
  }
  // 处理支付逻辑
  @promiseLock
  payHandle() {
    if (this.isPaySuccess || !this.isAgree) {
      return;
    }
    this.track('ButtonClick', {
      tracking_subscene: '发起付款',
      button_name: '立即购买',
      button_type: '普通按钮',
      actual_price: this.price,
      page_name: this.sensorData.page_name || 'unknown',
    });
    clearTimeout(this.timeout);
    const channel = getChannel(PayChannel.WXAuto);
    const payLoad: any = {
      channel,
      result_url: window.location.href,
    };
    if (this.sensorData.page_name) {
      payLoad.page_name = this.sensorData.page_name; // 页面名，后端有给就带
    }
    let charge;
    return window.apis
      .postPayCharge(
        payLoad,
        { id: 9 },
        { ...this.$route.query, ...getQueryFromSearch() }
      )
      .catch((e: any) => {
        this.toast({ type: 'error_network' });
        throw 'network';
      })
      .then((res: any) => {
        if (res.errcode === 0 && res.data && res.data.charge) {
          const charge = res.data.charge;
          this.processCharge(charge);
          clearTimeout(this.timeout);
          this.startPollCharge(charge.id);
          return executeCharge(charge);
        } else {
          throw res;
        }
      })
      .then((res: string) => {
        this.handlePaySuccess();
      })
      .catch((e: any) => {
        if (e !== 'network') {
          this.toast({ type: 'warn', value: '支付失败' });
        }
      });
  }
  processCharge(charge: { id: string }) {
    setItem(this.storeKey, charge.id);
    this.chargeId = charge.id;
  }
  handlePaySuccess() {
    this.setLoading(true);
    this.isPaySuccess = true;
    this.startPollCharge(this.chargeId);
  }
  handleFail(e: any) {
    this.toast('处理错误');
  }
  handlePollSuccess() {
    this.setLoading(false);
    // this.isShowPopup = true;
    this.hasQualify = true;
    this.isPaySuccess = true;
    if (this.successUrl) {
      window.location.replace(this.successUrl);
    } else {
      this.isShowPopup = true;
    }
  }
  startPollCharge(id: string) {
    const next = () => {
      this.timeout = setTimeout(() => {
        this.startPollCharge(id);
      }, 3000);
    };
    window.apis
      .getWapChargeStatus({ id }, this.$route.query)
      .then((res: any) => {
        const { data } = res;
        if (data.is_success) {
          if (data.send_track) {
            this.trackerPromise &&
              this.trackerPromise.then(tracker =>
                tracker.completePay(this.convertId)
              );
          }
          this.handlePollSuccess();
        } else {
          next();
        }
      })
      .catch(() => {
        next();
      });
  }
  styleFix() {
    if (/ByteLocale/.test(window.navigator.userAgent)) {
      document.body.style.minHeight = '100vh';
    }
  }
  beforeDestroy() {
    clearTimeout(this.timeout);
    this.scrollTracker && this.scrollTracker.revoke();
  }
}
</script>

<style lang="scss" scoped>
.main-block {
  width: 100%;
  // padding-bottom: 108px;
  // background:
  img {
    width: 100%;
  }
}
.bottom-block {
  height: 108px;
  background: skyblue;
}
</style>
